import {
    Component
} from '@angular/core';
import {
    TaskBaseMagicComponent,
    magicProviders
} from "@magic-xpa/angular";
@Component({
    selector: 'mga-MenuOpcoes',
    providers: [...magicProviders],
	styleUrls: ['./MenuOpcoes.component.css', './reset.css'],
    templateUrl: './MenuOpcoes.component.html'
}) export class MenuOpcoes extends TaskBaseMagicComponent {
	
	/* Added in JUN/2023, for Profule Image support */  
	showImage = false;	
	
}